export default __webpack_public_path__ + "static/media/delete.b8cd6806.svg";